import React, { useState, useEffect } from 'react';
import cataloguesPut from './cataloguesPut';
import { get } from './axios_call';

export default (imageId, setShow) => {
  const [catalogues, setCatalogues] = useState([]);
  useEffect(() => {
    let sourceOuter;
    get('catalogues', true).then(([res, source]) => {
      sourceOuter = source;
      setCatalogues(
        res.data.map((catalogue) => (
          <p
            onClick={() => { cataloguesPut(catalogue.hash, imageId); setShow(false); }}
            id={catalogue.id}
            key={catalogue.id}
            style={{ cursor: 'pointer' }}
          >
            {catalogue.title}
          </p>
        )),
      );
    });
    return () => {
      sourceOuter.cancel();
    };
  }, [imageId, setShow]);
  return catalogues;
};
